
export default function getFontFamilies(lang) {
  return {
    0: {
      font: 'Allura',
      name: `${lang.creative}-Allura`,
    },
    1: {
      font: 'Charmonman',
      name: `${lang.creative}-Charmonman`,
    },
    2: {
      font: 'DancingScript',
      name: `${lang.creative}-DancingScript`,
    },
    3: {
      font: 'GreatVibes',
      name: `${lang.creative}-GreatVibes`,
    },
    4: {
      font: 'Italianno',
      name: `${lang.creative}-Italianno`,
    },
    5: {
      font: 'KaushanScript',
      name: `${lang.creative}-KaushanScript`,
    },
    6: {
      font: 'MarckScript',
      name: `${lang.creative}-MarckScript`,
    },
    7: {
      font: 'Pacifico',
      name: `${lang.creative}-Pacifico`,
    },
    8: {
      font: 'PetitFormalScript',
      name: `${lang.creative}-PetitFormalScript`,
    },
    9: {
      font: 'Sacramento',
      name: `${lang.creative}-Sacramento`,
    },
    10: {
      font: 'Barlow',
      name: `${lang.standard}-Barlow`,
    },
    11: {
      font: 'Capriola',
      name: `${lang.standard}-Capriola`,
    },
    12: {
      font: 'Kodchasan',
      name: `${lang.standard}-Kodchasan`,
    },
    13: {
      font: 'Montserrat',
      name: `${lang.standard}-Montserrat`,
    },
    14: {
      font: 'OpenSans',
      name: `${lang.standard}-OpenSans`,
    },
    15: {
      font: 'OpenSansCondensed',
      name: `${lang.standard}-OpenSansCondensed`,
    },
    16: {
      font: 'SourceSansPro',
      name: `${lang.standard}-SourceSansPro`,
    },
    17: {
      font: 'Thasadith',
      name: `${lang.standard}-Thasadith`,
    },
    18: {
      font: 'VarelaRound',
      name: `${lang.standard}-VarelaRound`,
    },
  };
}



// WEBPACK FOOTER //
// ./src/components/text-tools/font-family/Fonts.js